'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var ClientData = (0, _immutable.Record)({
  chatConfig: null,
  client: null,
  connectionInProgress: false,
  forceClientOffline: false,
  isAdmin: true,
  isInForeground: true,
  isPubNubClientConnected: false,
  serverTimeOffsetInMs: 0,
  timestamps: (0, _immutable.OrderedMap)(),
  uuid: null
}, 'ClientData');

exports.default = ClientData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/ClientData.js
// module id = 243
// module chunks = 2 3